import { useLoadScript } from './useLoadScript'

// See documentation for device fingerprinting / decisionmaker
// https://confluence.ops.expertcity.com/x/L4UVIg
// https://confluence.ops.expertcity.com/x/7um3Cw
// https://confluence.ops.expertcity.com/x/cxthC

export const useMetrixScript = (shouldLoadScript: boolean, orgId: string, sessionId: string, merchantId: string) => {
    return useLoadScript(
        `https://cdn-east.purchase.goto.com/fp/tags.js?org_id=${orgId}&session_id=${merchantId}${sessionId}`,
        shouldLoadScript
    )
}
